import React, { PureComponent } from 'react'
import { string, func } from 'prop-types'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import FormStaticField from '@active/react-ui/FormStaticField'
import EmailInput from '@active/react-ui/EmailInput'
import PasswordInput from '@active/react-ui/PasswordInput'
import Link from '@active/react-ui/Link'
import Button from '@active/react-ui/Button'
import { withI18n } from '@active/react-utils/i18n'
import Identity from '@active/react-utils/components/Identity'

import I18nMessage from '../I18nMessage'
import './LinkAccountContent.scss'
import connectLocale from '../../../shared/utils/connectLocale'

const ACCOUNT_TYPE_TIPS_CONFIG = {
  IDP_FACEBOOK: 'passport.linkAccount.text.thereIsActiveAccount.facebook',
  IDP_APPLE: 'passport.linkAccount.text.thereIsActiveAccount.apple',
  IDP_SPARTAN: 'passport.linkAccount.text.thereIsActiveAccount.spartan',
  IDP_IRONMAN: 'passport.linkAccount.text.thereIsActiveAccount.ironman',
  IDP_TIMETO: 'passport.linkAccount.text.thereIsActiveAccount.timeTo',
}

function emptyValidator(value) {
  if (!value) {
    return 'passport.error.validation.noPassword'
  }
  return undefined
}

class LinkAccountContent extends PureComponent {
  static propTypes = {
    locale: string.isRequired,
    passportAPIServerHost: string.isRequired,
    updateProfile: func.isRequired,
    signinToLink: func.isRequired,

    cleanState: func.isRequired,
    email: string,
    identityProviderAlias: string.isRequired,
    kcErrorMessage: string,
    Body: func,
    Footer: func,
  }

  static defaultProps = {
    email: '',
    kcErrorMessage: '',
    Body: Identity,
    Footer: Identity,
  }

  submitFormTrigger

  constructor(props) {
    super(props)
    this.state = {
      errorMessage: props.kcErrorMessage,
    }
  }

  componentDidUpdate(prevProps) {
    const { kcErrorMessage } = this.props
    if (prevProps.kcErrorMessage !== kcErrorMessage) {
      this.setState({ errorMessage: kcErrorMessage })
    }
  }

  handleSubmit = async values => {
    const { signinToLink } = this.props
    await signinToLink({
      email: values.email,
      password: values.pswd,
    })
  }

  handleChange = ({ values }) => {
    this.setState({ pswd: values.pswd })
    const { cleanState } = this.props

    if (cleanState) {
      cleanState()
    }
  }

  handleForgotPawd = () => {
    const { passportAPIServerHost, locale } = this.props

    const forgotPwdUrl = new URL(`${passportAPIServerHost}/page/forgotPwd`)
    forgotPwdUrl.searchParams.append('username', this.formRef.values.email)
    forgotPwdUrl.searchParams.append('username_readonly', true)
    forgotPwdUrl.searchParams.append('count_to_close', true)
    forgotPwdUrl.searchParams.append('locale', locale)
    window.open(forgotPwdUrl.toString())
  }

  render() {
    const {
      email, identityProviderAlias, updateProfile, Body, Footer,
    } = this.props
    const { pswd, errorMessage } = this.state

    return (
      <Identity>
        <Body>
          <div className="passport-content link-account">
            <div className="link-account__description">
              <I18nMessage id={ACCOUNT_TYPE_TIPS_CONFIG[identityProviderAlias]} />
            </div>
            <Form
              onSubmit={this.handleSubmit}
              onChange={this.handleChange}
              initialValues={{ email: email, pswd: pswd }}
            >
              <FormGroup name="email" withoutLayout required>
                <FormLabel>
                  <I18nMessage id="passport.common.label.emailAddress" />
                </FormLabel>
                {email
                  ? <FormStaticField as={EmailInput} />
                  : (
                    <FormField
                      as={EmailInput}
                      requiredError="passport.error.validation.invalidEmail"
                      invalidError="passport.error.validation.invalidEmail"
                    />
                  )}
              </FormGroup>

              <FormGroup name="pswd" withoutLayout required>
                <FormLabel>
                  <I18nMessage id="passport.common.label.password" />
                </FormLabel>
                <FormField maxLength={50} validate={emptyValidator} as={PasswordInput} warning={errorMessage} />
              </FormGroup>
              <FormConsumer>
                {({ form }) => {
                  this.formRef = form
                  this.submitFormTrigger = form.submitForm
                  return null
                }}
              </FormConsumer>
            </Form>
            <div>
              <Link tabIndex={0} onClick={this.handleForgotPawd} className="passport__signin__forgot-pawd">
                <I18nMessage id="passport.signin.label.forgotPassword" />
              </Link>
            </div>
          </div>
        </Body>
        <Footer>
          <div className="passport-content-footer link-account-content-footer">
            <Button type="super" className="btn-signin-link" onClick={this.submitFormTrigger}>
              <I18nMessage id="passport.common.btn.SignInToLink" />
            </Button>
            <Button type="secondary" onClick={updateProfile}>
              <I18nMessage id="passport.common.btn.back" />
            </Button>
          </div>
        </Footer>
      </Identity>
    )
  }
}

export default withI18n(connectLocale(LinkAccountContent))
